<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Visitors'}">
              <h4 class="ms-2">
                {{label.pages.visitors}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{label.pages.requestList}}
              </small>
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="true"
              :data-source="branches"
              :columns="fields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.pages.search"
            />
            <DxColumnChooser
                :enabled="true"
                mode="dragAndDrop"
            />
            <DxExport
                :enabled="true"
            />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                        variant="ps-success"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.addBranch"
                        @click="add"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.reload"
                        @click="reloadData"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-0">
                  <button
                      @click="edit(data)"
                      :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0">
                  <button
                      @click="delConfirm(data)"
                      :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0">
                  <button
                      @click="detail(data)"
                      :id="'showDetailsBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="filter-square-fill" scale="1.1" variant="ps-tools-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'showDetailsBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.showDetails }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!--  Add Modal -->
    <b-modal
        dir="rtl"
        v-model="addModal"
        size="lg"
        header-bg-variant="ps-success"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.buttons.addBranch}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="addModal=false"
            id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col cols="12" class="mb-2 mt-1">
                <label for="companyName" class="ps_label pe-2">
                  {{label.pages.theCompanyName}}
                  <span class="ps_label_star">*</span>
                </label>
                <b-form-input id="companyName" size="sm" v-model="form.companyName"/>
          </b-col>
          <b-col cols="6" class="my-2">
                <label for="firstName" class="ps_label pe-2">
                  {{label.form.firstName}}
                  <span class="ps_label_star">*</span>
                </label>
                <b-form-input id="firstName" size="sm" v-model="form.firstName"/>
          </b-col>
          <b-col cols="6" class="my-2">
                <label for="lastName" class="ps_label pe-2">
                  {{label.form.lastName}}
                  <span class="ps_label_star">*</span>
                </label>
                <b-form-input id="lastName" size="sm" v-model="form.lastName"/>
          </b-col>
          <b-col cols="6" class="my-2">
                <label for="activity" class="ps_label pe-2">
                  {{label.form.activityField}}
                </label>
                <b-form-input id="activity" size="sm" v-model="form.activity"/>
          </b-col>

          <b-col cols="6" class="my-2">
            <label for="mobileNumber" class="ps_label pe-2">
              {{label.form.mobileNumber}}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="mobileNumber" size="sm" type="number" v-model="form.mobileNumber"/>
          </b-col>

          <b-col cols="6" class="my-2">
                <label for="phone" class="ps_label pe-2">
                  {{label.form.phoneNumber}}
                </label>
                <b-form-input id="phone" size="sm" type="number" v-model="form.phone"/>
          </b-col>

          <b-col cols="6" class="my-2">
            <label for="email" class="ps_label pe-2">
              {{label.form.email}}
            </label>
            <b-form-input id="email" size="sm" type="email" dir="ltr" v-model="form.email"/>
          </b-col>

          <b-col cols="6" class="my-2">
                <label for="state" class="ps_label pe-2">
                  {{label.form.province}}
                  <span class="ps_label_star">*</span>
                </label>
                <treeselect
                    id="state"
                    :placeholder="label.pages.search"
                    :options="states"
                    v-model="selectedState"
                    :normalizer="normalizer"
                    @input="getProvince"
                ></treeselect>
          </b-col>
          <b-col cols="6" class="my-2">
                <label for="city" class="ps_label pe-2">
                  {{label.form.city}}
                  <span class="ps_label_star">*</span>
                </label>
                <treeselect
                    :placeholder="label.pages.search"
                    id="city"
                    :options="cities"
                    v-model="form.cityId"
                    :normalizer="normalizer"
                    :noOptionsText="label.errors.chooseProvince"
                ></treeselect>
          </b-col>

          <b-col cols="12" class="my-2">
                <label for="experience" class="ps_label pe-2">
                  {{ label.form.experience }}
                </label>
                <b-form-textarea id="experience" size="sm" v-model="form.experience"/>
          </b-col>
          <b-col cols="12" class="my-2">
                <label for="address" class="ps_label pe-2">
                  {{label.form.address}}
                </label>
                <b-form-textarea
                  id="address"
                  size="sm"
                  v-model="form.address"
                  rows="1"
                ></b-form-textarea>
          </b-col>
          <b-col cols="12" class="my-2">
                <label for="description" class="ps_label pe-2">{{label.form.description}}</label>
                <b-form-textarea id="description" size="sm" v-model="form.description"/>
          </b-col>
          <b-col cols="6" >
            <b-row v-if="dropZoneAction" class="mt-3">
              <b-col>
                <drop-zone-custom
                    mode="file"
                    :isRequired="true"
                    :add="dropZoneAction"
                    :edit="!dropZoneAction"
                    :editSrc="form.fileAddress"
                />
              </b-col>
            </b-row>
            <b-row v-if="!dropZoneAction" class="my-3">
              <b-col>
                <drop-zone-custom
                    mode="file"
                    :isRequired="true"
                    :add="dropZoneAction"
                    :edit="!dropZoneAction"
                    :editSrc="form.fileAddress"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col cols="auto">
                <label for="display" class="ps_label">
                  {{label.form.display}}
                </label>
              </b-col>
              <b-col>
                <label class="ps-switch">
                  <input type="checkbox" v-model="form.isConfirm">
                  <span class="slider round"></span>
                </label>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="addModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="addBranch"
            >
            {{label.buttons.submitInfo}}
            </b-button>
            <b-button
                v-else
                variant="ps-success"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <!-- edit Modal -->
    <b-modal
        dir="rtl"
        v-model="editModal"
        header-bg-variant="ps-warning"
        size="lg"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.editAgency}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editModal=false"
            id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row>
          <b-col cols="12" class="mb-2 mt-1">
            <label for="companyName" class="ps_label pe-2">
              {{label.pages.theCompanyName}}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="companyName" size="sm" v-model="form.companyName"/>
          </b-col>
          <b-col cols="6" class="my-2">
            <label for="firstName" class="ps_label pe-2">
              {{label.form.firstName}}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="firstName" size="sm" v-model="form.firstName"/>
          </b-col>
          <b-col cols="6" class="my-2">
            <label for="lastName" class="ps_label pe-2">
              {{label.form.lastName}}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="lastName" size="sm" v-model="form.lastName"/>
          </b-col>
          <b-col cols="6" class="my-2">
            <label for="activity" class="ps_label pe-2">
              {{label.form.activityField}}
            </label>
            <b-form-input id="activity" size="sm" v-model="form.activity"/>
          </b-col>

          <b-col cols="6" class="my-2">
            <label for="mobileNumber" class="ps_label pe-2">
              {{label.form.mobileNumber}}
              <span class="ps_label_star">*</span>
            </label>
            <b-form-input id="mobileNumber" size="sm" type="number" v-model="form.mobileNumber"/>
          </b-col>

          <b-col cols="6" class="my-2">
            <label for="phone" class="ps_label pe-2">
              {{label.form.phoneNumber}}
            </label>
            <b-form-input id="phone" size="sm" type="number" v-model="form.phone"/>
          </b-col>

          <b-col cols="6" class="my-2">
            <label for="email" class="ps_label pe-2">
              {{label.form.email}}
            </label>
            <b-form-input id="email" size="sm" type="email" dir="ltr" v-model="form.email"/>
          </b-col>

          <b-col cols="6" class="my-2">
            <label for="state" class="ps_label pe-2">
              {{label.form.province}}
              <span class="ps_label_star">*</span>
            </label>
            <treeselect
                    id="state"
                    :placeholder="label.pages.search"
                    :options="states"
                    v-model="selectedState"
                    :normalizer="normalizer"
                    @input="getProvince"
            ></treeselect>
          </b-col>
          <b-col cols="6" class="my-2">
            <label for="city" class="ps_label pe-2">
              {{label.form.city}}
              <span class="ps_label_star">*</span>
            </label>
            <treeselect
                    :placeholder="label.pages.search"
                    id="city"
                    :options="cities"
                    v-model="form.cityId"
                    :normalizer="normalizer"
                    :noOptionsText="label.errors.chooseProvince"
            ></treeselect>
          </b-col>

          <b-col cols="12" class="my-2">
            <label for="experience" class="ps_label pe-2">
              {{ label.form.experience }}
            </label>
            <b-form-textarea id="experience" size="sm" v-model="form.experience"/>
          </b-col>
          <b-col cols="12" class="my-2">
            <label for="address" class="ps_label pe-2">
              {{label.form.address}}
            </label>
            <b-form-textarea
                    id="address"
                    size="sm"
                    v-model="form.address"
                    rows="1"
            ></b-form-textarea>
          </b-col>
          <b-col cols="12" class="my-2">
            <label for="description" class="ps_label pe-2">{{label.form.description}}</label>
            <b-form-textarea id="description" size="sm" v-model="form.description"/>
          </b-col>
          <b-col cols="6" >
            <b-row v-if="dropZoneAction" class="mt-3">
              <b-col>
                <drop-zone-custom
                        mode="file"
                        :isRequired="true"
                        :add="dropZoneAction"
                        :edit="!dropZoneAction"
                        :editSrc="form.fileAddress"
                />
              </b-col>
            </b-row>
            <b-row v-if="!dropZoneAction" class="my-3">
              <b-col>
                <drop-zone-custom
                        mode="file"
                        :isRequired="true"
                        :add="dropZoneAction"
                        :edit="!dropZoneAction"
                        :editSrc="form.fileAddress"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="my-3">
              <b-col cols="auto">
                <label for="display" class="ps_label">
                  {{label.form.display}}
                </label>
              </b-col>
              <b-col>
                <label class="ps-switch">
                  <input type="checkbox" v-model="form.isConfirm">
                  <span class="slider round"></span>
                </label>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="editModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1"
                @click="editBranch"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                variant="ps-warning"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal
        dir="rtl"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteBranch"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Detail Modal -->
    <b-modal
        dir="rtl"
        v-model="detModal"
        centered
        hide-footer
        hide-header
        size="md"
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center">
            <small>{{label.pages.theCompanyName}}: </small>
            <strong>{{ branch.companyName }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.city}}: </small>
            <strong>{{ branch.cityId }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.firstName}}: </small>
            <strong>{{ branch.firstName }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.lastName}}: </small>
            <strong>{{ branch.lastName }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.ThePhoneNumber}}: </small>
            <strong>{{ branch.phone }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.form.phoneNumber}}: </small>
            <strong>{{ branch.mobileNumber }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.email}}: </small>
            <strong>{{ branch.email }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.areaOfActivity}}: </small>
            <strong>{{ branch.activity }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.history}}: </small>
            <strong>{{ branch.experience }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.dateOfRequest}}: </small>
            <strong>{{ branch.createdLocal }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.theAddress}}: </small>
            <strong>{{ branch.address }}</strong>
          </p>
          <small class="fs9 text-center">
              {{label.pages.description}}
          <b-icon icon="arrow90deg-down" scale="0.7" />
          </small>
          <p class="fs9 text-center bg-light p-2 rounded lh1">
            <strong>{{ branch.description }}</strong>
          </p>
          <b-button variant="ps-primary" @click="download(branch)">دریافت فایل رزومه</b-button>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="detModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import dropZoneCustom from '@/components/DropZoneCustom'
import alert from '@/plugins/AlertMessages.js'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'BranchesPage',
  mixins: [dataGridMixin],
  components: {
    Treeselect,
    dropZoneCustom
  },
  data() {
    return {
      label,
      refreshfile: true,
      dropZoneAction: true,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '80',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '120',
          alignment: 'center'
        },
        {
          dataField: 'companyName',
          caption: 'نام شرکت',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'firstName',
          caption: 'نام',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'lastName',
          caption: 'نام خانوادگی',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'createdLocal',
          caption: 'تاریخ ثبت',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'isConfirm',
          caption: 'وضعیت نمایش',
          dataType: 'boolean',
          alignment: 'center'
        },
      ],
      addModal: null,
      editModal: null,
      editId: null,
      delId: null,
      delModal: false,
      delTitle: null,
      detModal: null,
      file: null,
      form: {
        fileName: '',
        fileAddress: null,
        cityId: null,
        companyName: null,
        firstName: null,
        lastName: null,
        activity: null,
        phone: null,
        mobileNumber: null,
        address: null,
        email: null,
        experience: null,
        description: null,
        isConfirm: true,
      },
      selectedState: null,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      branches: 'baseX/branches',
      branch: 'baseX/branch',
      loadingBtn: 'loadingBtn',
      states: 'baseX/province',
      cities: 'baseX/cities',
      fileUrl: 'fileUrl',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.addModal = false;
        this.editModal = false;
        this.delModal = false;
        this.reloadFields();
        this.reloadData();
      }
    },
    fileUrl() {
      if (this.fileUrl && this.fileUrl.length > 0) {
        this.refreshfile = false
        this.dropZoneAction = false
        this.form.fileName = this.fileUrl[0].fullPath
        this.form.fileAddress = this.fileUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshfile = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.title,
      }
    },
    getProvince() {
      this.form.cityId = null;
      if(this.selectedState) {
        this.$store.dispatch('baseX/getCities', this.selectedState);
      }
    },
    detail(item) {
      const ids = [];
      ids.push(item.data.id);
      this.$store.dispatch('baseX/isAdminReadBranch', ids);
      this.$store.dispatch('baseX/getBranchById', item.data.id);
      this.detModal = true;
    },
    download(item) {
      if(item.fileAddress !== '' && item.fileAddress !== null) {
        window.open(item.fileAddress, '_blank');
      } else {
        this.$store.commit('setInfo', alert.error.notFound)
      }
    },
    add() {
      this.reloadFields();
      this.dropZoneAction = true;
      this.$store.commit("setUrlsEmpty");
      this.addModal = true;
    },
    addBranch() {
      this.$store.commit("setLoadingBtn", true);
      if(this.form.companyName && this.form.companyName != ''
        && this.form.firstName && this.form.firstName != ''
        && this.form.lastName && this.form.lastName != ''
        && this.form.mobileNumber && this.form.mobileNumber != ''
        && this.form.cityId ) {
        let formData = new FormData();
        if (this.form.cityId) {
          formData.append('CityId', this.form.cityId);
        }
        if (this.form.companyName) {
          formData.append('CompanyName', this.form.companyName);
        }
        if (this.form.firstName) {
          formData.append('FirstName', this.form.firstName);
        }
        if (this.form.lastName) {
          formData.append('LastName', this.form.lastName);
        }
        if (this.form.activity) {
          formData.append('Activity', this.form.activity);
        }
        if (this.form.phone) {
          formData.append('Phone', this.form.phone);
        }
        if (this.form.mobileNumber) {
          formData.append('MobileNumber', this.form.mobileNumber);
        }
        if (this.form.address) {
          formData.append('Address', this.form.address);
        }
        if (this.form.email) {
          formData.append('Email', this.form.email);
        }
        if (this.form.experience) {
          formData.append('Experience', this.form.experience);
        }
        if (this.form.description) {
          formData.append('Description', this.form.description);
        }
        if (this.form.fileName) {
          formData.append('FileName', this.form.fileName);
        }
        formData.append('IsConfirm', this.form.isConfirm);
        this.$store.dispatch('baseX/addBranch', formData);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    edit(item)  {
      this.selectedState = item.data.provinceId;
      this.getProvince();
      this.editId = item.data.id;
      this.form = {
        fileName: item.data.fileName,
        fileAddress: item.data.fileAddress,
        cityId: item.data.cityId,
        companyName: item.data.companyName,
        firstName: item.data.firstName,
        lastName: item.data.lastName,
        activity: item.data.activity,
        phone: item.data.phone,
        mobileNumber: item.data.mobileNumber,
        address: item.data.address,
        email: item.data.email,
        experience: item.data.experience,
        description: item.data.description,
        isConfirm: item.data.isConfirm,
      };
      this.editModal = true;
    },
    editBranch() {
      this.$store.commit("setLoadingBtn", true);
      if(this.form.companyName && this.form.companyName != ''
        && this.form.firstName && this.form.firstName != ''
        && this.form.lastName && this.form.lastName != ''
        && this.form.mobileNumber && this.form.mobileNumber != ''
        && this.form.cityId && this.form.cityId > 0) {
        let formData = new FormData();
        if (this.form.cityId) {
          formData.append('CityId', this.form.cityId);
        }
        if (this.form.companyName) {
          formData.append('CompanyName', this.form.companyName);
        }
        if (this.form.firstName) {
          formData.append('FirstName', this.form.firstName);
        }
        if (this.form.lastName) {
          formData.append('LastName', this.form.lastName);
        }
        if (this.form.activity) {
          formData.append('Activity', this.form.activity);
        }
        if (this.form.phone) {
          formData.append('Phone', this.form.phone);
        }
        if (this.form.mobileNumber) {
          formData.append('MobileNumber', this.form.mobileNumber);
        }
        if (this.form.address) {
          formData.append('Address', this.form.address);
        }
        if (this.form.email) {
          formData.append('Email', this.form.email);
        }
        if (this.form.experience) {
          formData.append('Experience', this.form.experience);
        }
        if (this.form.description) {
          formData.append('Description', this.form.description);
        }
        if (this.form.fileName) {
          formData.append('FileName', this.form.fileName);
        }
        formData.append('IsConfirm', this.form.isConfirm);
        const values = {
          id: this.editId,
          value: formData
        };
        this.$store.dispatch('baseX/editBranch', values);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    delConfirm(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.companyName;
      this.delModal = true;
    },
    deleteBranch() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteBranch', this.delId);
      this.delModal = false;
    },
    reloadFields() {
      this.form = {
        cityId: null,
        companyName: null,
        firstName: null,
        lastName: null,
        activity: null,
        phone: null,
        mobileNumber: null,
        address: null,
        email: null,
        experience: null,
        description: null,
        isConfirm: true,
      };
      this.file = null;
      this.selectedState = null;
      this.$store.commit("baseX/setCitiesEmpty");
    },
    reloadData() {
      this.$store.dispatch('baseX/getBranches');
    },
  },
  mounted() {
    this.reloadData();
    this.$store.dispatch('baseX/getProvince');
  },
}
</script>
